module.exports = __webpack_public_path__ + "img/glyphicons-halflings-regular.svg?89889688147bd7575d6327160d64e760";


//////////////////
// WEBPACK FOOTER
// ./src/assets/plugins/bootstrapv3/fonts/glyphicons-halflings-regular.svg
// module id = 590
// module chunks = 0